<navbar></navbar>
<div class="main-page">
  <div class="main-container" id="main-page">
    <forgot-password></forgot-password>
    <router-outlet></router-outlet>
    <div class="main-container-right-side">
      <current-slip-core></current-slip-core>
      <side-banner [_sblocationid]="2"></side-banner>
    </div>
  </div>
  <ng-container [ngSwitch]="['b500', 'betarena'] | getProductName">
    <ng-container *ngSwitchCase="'b500'"> </ng-container>
    <ng-container *ngSwitchCase="'terminalPeru'"> </ng-container>

    <ng-container *ngSwitchCase="'betarena'"> </ng-container>
    <ng-container *ngSwitchDefault>
      <div class="footer" *ngIf="this._UiHelper.footerIsActive">
        <footer-component></footer-component>
      </div>
    </ng-container>
  </ng-container>
  <account-mobile></account-mobile>
</div>

<div class="bottom-navbar">
  <bottom-navbar></bottom-navbar>
</div>

<ng-container *ngIf="isMobileView">
  <!--  *ngIf="isMobileView && !quickTippIsActive" => Test edilecek-->
  <bottom-dialog></bottom-dialog>
</ng-container>
<ng-container *ngIf="isMobileView">
  <match-detail-dialog></match-detail-dialog>
</ng-container>
<ng-container *ngIf="isMobileView">
  <ng-container [ngSwitch]="['b500'] | getProductName">
    <ng-container *ngSwitchCase="'b500'">
      <quick-tipp *ngIf="quickTippIsActive" (closeQuickTippOutput)="closeQuickTippOutput($event)"></quick-tipp>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <quick-tipp *ngIf="quickTippIsActive && this._DataHelper.selectedWallet.BranchType != 0" (closeQuickTippOutput)="closeQuickTippOutput($event)"></quick-tipp>
    </ng-container>
  </ng-container>
</ng-container>
